(function () {
    'use strict';

    angular
        .module('aricControllers')
        .controller('AricControlsByOwnerController', Controller);

    Controller.$inject = ['$scope', '$state', '$stateParams', 'controlsByOwner'];

    function Controller($scope, $state, $stateParams, controlsByOwner) {
        //topBarService.setTitleAndIcon('ARIC', 'fa fa-eye');

        $scope.controlOwnerId                  = $stateParams.OwnerID;
        $scope.pendingInformationControls      = _.filter(controlsByOwner, { ControlStatusValue: 'PendingInformation' });
        $scope.readyForTestingControls         = _.filter(controlsByOwner, { ControlStatusValue: 'ReadyForTesting' });
        $scope.testingInProgressControls       = _.filter(controlsByOwner, { ControlStatusValue: 'TestingInProgress' });
        $scope.testingToReviewControls         = _.filter(controlsByOwner, { ControlStatusValue: 'ControlTestingToReview' });
        $scope.readyForCertificationControls   = _.filter(controlsByOwner, { ControlStatusValue: 'ReadyForCertification' });
        $scope.certificationInProgressControls = _.filter(controlsByOwner, { ControlStatusValue: 'CertificationInProgress' });
        $scope.certificationToReviewControls   = _.filter(controlsByOwner, { ControlStatusValue: 'CertificationToReview' });
        $scope.completedControls               = _.filter(controlsByOwner, { ControlStatusValue: 'Completed' });

        // Go To Control
        $scope.goToControl = function (control, $event) {
            $state.go('control', {
                ControlID: control.ControlID,
                ctxStateName: $state.current.name,
                ctxStateParams: _.cloneDeep($stateParams),
                ctxItem: _.cloneDeep($scope.controlOwner)
            });

            $event.stopPropagation();
        };

        // Go To Control Assessment
        $scope.goToControlAssessment = function (control, $event) {
            $state.go('control.assessment', {
                ControlID: control.ControlID,
                ctxStateName: $state.current.name,
                ctxStateParams: _.cloneDeep($stateParams),
                ctxItem: _.cloneDeep($scope.controlOwner)
            });

            $event.stopPropagation();
        };
    }
})();